export default async ({ commit, state, dispatch }) => {
    let videoPrice = state.priceVideo.value

    await dispatch('setDuration', null, {root: false})

    let duration = state.duration

    var minutes = Math.trunc(duration / 60);
    var seconds = duration % 60;
    if (minutes > 0) {
        var sec_intervals = Math.trunc(seconds / 15) + 1;
        minutes += sec_intervals / 4;
    } else {
        minutes = 1;
    }
    commit('setPriceDuration', {
        value: Math.trunc(videoPrice * minutes)
    })
}